import { Component } from '@angular/core';

@Component({
  selector: 'tekman-private-mode',
  templateUrl: './private-mode.component.html',
  styleUrls: ['./private-mode.component.scss']
})
export class PrivateModeComponent {}
